// people.js
// -----------------------------------------------------------------------------
// Turns the identity a record stores -- the email the account had when it
// wrote it, or a uid -- into the person's full name, and decides whether a
// record belongs to the signed-in user.
//
// Records are never rewritten when an account moves to a user ID, so an old
// booking still holds the old email. Both questions therefore look at EVERY
// email an account has had (userProfile.previousEmails), not just its current
// one.
//
// Pure -- no Firestore, no Vue -- asserted by `npm run test:users`, which also
// checks identitiesOf agrees with functions/userProfile.js.
// -----------------------------------------------------------------------------

function identitiesOf (profile, email) {
  const all = [email].concat((profile && profile.previousEmails) || [])
  const out = []
  all.forEach(e => { if (e && out.indexOf(e) === -1) out.push(e) })
  return out
}

function buildDirectory (profiles) {
  const map = {}
  const list = profiles || []
  list.forEach(p => {
    const name = p && String(p.fullName || '').trim()
    if (!name) return
    const keys = [p.uid].concat(identitiesOf(p, p.email))
    keys.forEach(key => {
      if (key) map[key] = name
    })
  })
  return map
}

// An identity nobody has named yet shows as stored, so nothing becomes blank.
function nameOf (directory, identity) {
  if (!identity) return ''
  return (directory && directory[identity]) || identity
}

function ownedBy (value, identities) {
  return !!value && (identities || []).indexOf(value) !== -1
}

module.exports = { identitiesOf, buildDirectory, nameOf, ownedBy }
